"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.listParts = void 0;
const aws_client_utils_1 = require("@aws-amplify/core/internals/aws-client-utils");
const utils_1 = require("@aws-amplify/core/internals/utils");
const composers_1 = require("@aws-amplify/core/internals/aws-client-utils/composers");
const base_1 = require("./base");
const utils_2 = require("./utils");
const listPartsSerializer = async (input, endpoint) => {
    const headers = {};
    const url = new utils_1.AmplifyUrl(endpoint.url.toString());
    (0, utils_2.validateS3RequiredParameter)(!!input.Key, 'Key');
    url.pathname = (0, utils_2.serializePathnameObjectKey)(url, input.Key);
    (0, utils_2.validateS3RequiredParameter)(!!input.UploadId, 'UploadId');
    url.search = new utils_1.AmplifyUrlSearchParams({
        uploadId: input.UploadId,
    }).toString();
    return {
        method: 'GET',
        headers,
        url,
    };
};
const listPartsDeserializer = async (response) => {
    if (response.statusCode >= 300) {
        const error = (await (0, utils_2.parseXmlError)(response));
        throw (0, utils_2.buildStorageServiceError)(error, response.statusCode);
    }
    else {
        const parsed = await (0, utils_2.parseXmlBody)(response);
        const contents = (0, utils_2.map)(parsed, {
            UploadId: 'UploadId',
            Parts: [
                'Part',
                value => (0, utils_2.emptyArrayGuard)(value, deserializeCompletedPartList),
            ],
        });
        return {
            $metadata: (0, aws_client_utils_1.parseMetadata)(response),
            ...contents,
        };
    }
};
const deserializeCompletedPartList = (input) => input.map(item => (0, utils_2.map)(item, {
    PartNumber: ['PartNumber', utils_2.deserializeNumber],
    ETag: 'ETag',
    Size: ['Size', utils_2.deserializeNumber],
}));
exports.listParts = (0, composers_1.composeServiceApi)(utils_2.s3TransferHandler, listPartsSerializer, listPartsDeserializer, { ...base_1.defaultConfig, responseType: 'text' });
